import type { IconType } from 'react-icons';

import { useAuth } from '@/api/useAuth';
import { Icons } from '@/assets/Icons';
import { applicationsRoute, mockApisRoute } from '@/constants';
import { settings } from '@/settings';

export const comingSoon = 'Coming soon';

export type NavItemType = {
  label: string;
  description?: string;
  icon: IconType;
  to?: string;
  href?: string;
  disabled?: boolean;
};

export type NavGroupType = {
  label: string;
  items: NavItemType[];
};

export const isNavItemActive = (to: string | undefined, pathname: string) =>
  !!to && (pathname === to || pathname.startsWith(`${to}/`));

export const useNavGroups = (): NavGroupType[] => {
  const user = useAuth();
  const canAccessAdmin = !!user?.get('is_staff');

  return [
    {
      label: 'Platform',
      items: [
        {
          label: 'Command Centre',
          description: comingSoon,
          icon: Icons.LuCpu,
          disabled: true,
        },
        {
          label: 'Applications',
          description: 'Enterprise AI catalogue',
          icon: Icons.LuAppWindow,
          to: applicationsRoute,
        },
        {
          label: 'Development',
          description: comingSoon,
          icon: Icons.LuFlaskConical,
          disabled: true,
        },
        {
          label: 'Agents & MCP',
          description: comingSoon,
          icon: Icons.LuBot,
          disabled: true,
        },
        {
          label: 'Knowledge',
          description: comingSoon,
          icon: Icons.LuBookText,
          disabled: true,
        },
        {
          label: 'Mock APIs',
          description: 'Integration mocks',
          icon: Icons.LuWebhook,
          to: mockApisRoute,
        },
      ],
    },
    {
      label: 'Control',
      items: [
        {
          label: 'Governance',
          description: comingSoon,
          icon: Icons.LuLandmark,
          disabled: true,
        },
        {
          label: 'Observability',
          description: comingSoon,
          icon: Icons.LuSearchCheck,
          disabled: true,
        },
        ...(canAccessAdmin
          ? [
              {
                label: 'Super Admin',
                description: 'Site administration',
                icon: Icons.LuCloudCog,
                href: settings.ADMIN_URL,
              },
            ]
          : []),
      ],
    },
  ];
};
